// extracted by mini-css-extract-plugin
export default {"app__main":"out_app__main__h+I+o","main":"out_main__xIg2R","header":"out_header__7SFUK","text__container":"out_text__container__Kd+Bc","text":"out_text__xNDEM"};